import { BaseApiService } from '../../../api/base';
import type { UpdateIntroStateRequest } from '../types/questionnaire';
import type { UserOnboardingState } from '@/features/onboarding/types/onboarding';

class QuestionnaireApiService extends BaseApiService {
  async updateIntroState(request: UpdateIntroStateRequest): Promise<UserOnboardingState> {
    return this.put('/onboarding/intro-state', request);
  }
}

export const questionnaireApiService = new QuestionnaireApiService();
